import { toast } from "react-toastify";
import { AdministratorAPI, DashboardAPI } from "../constants/apiRoutes";
import { administratorActions } from "../reducers/administrator";
import apiService from "../utils/configAxios";
import { handleError } from "../utils/handleError";

export const createNewAdministrator = (data, navigate) => {
  return async (dispatch) => {
    dispatch(administratorActions.actionStart());
    try {
      await apiService.post(AdministratorAPI.create(), data);
      dispatch(administratorActions.actionSuccess("create"));
    } catch (err) {
      dispatch(administratorActions.clearError());
      handleError(err);
    }
  };
};

export const updateAdministrator = (data, navigate, id) => {
  return (dispatch) => {
    dispatch(administratorActions.actionStart());
    return apiService
      .put(AdministratorAPI.update(id), data)
      .then((response) => {
        dispatch(administratorActions.actionSuccess("update"));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const deleteAdministrator = (id) => {
  return (dispatch) => {
    return apiService
      .delete(AdministratorAPI.delete(id))
      .then((response) => {
        toast.success("Uspešno ste obrisali administratora", {
          theme: "colored",
        });

        dispatch(fetchAdministratorList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchAdministratorList = () => {
  return (dispatch) => {
    return apiService
      .get(AdministratorAPI.list())
      .then((response) => {
        dispatch(administratorActions.fetchAdministratorList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchAdministratorById = (id = 0) => {
  return (dispatch) => {
    return apiService
      .get(AdministratorAPI.getById(id))
      .then((response) => {
        dispatch(administratorActions.fetchAdministratorDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDashboardReel = () => {
  return (dispatch) => {
    return apiService
      .get(DashboardAPI.reel())
      .then((response) => {
        dispatch(administratorActions.fetchDashboardReel(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDashboardVideo = () => {
  return (dispatch) => {
    return apiService
      .get(DashboardAPI.video())
      .then((response) => {
        dispatch(administratorActions.fetchDashboardVideo(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDashboardCourse = () => {
  return (dispatch) => {
    return apiService
      .get(DashboardAPI.course())
      .then((response) => {
        dispatch(administratorActions.fetchDashboardCourse(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDashboardRevenue = () => {
  return (dispatch) => {
    return apiService
      .get(DashboardAPI.revenue())
      .then((response) => {
        dispatch(administratorActions.fetchDashboardRevenue(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchUserCountTotal = () => {
  return (dispatch) => {
    return apiService
      .get(DashboardAPI.userCountTotal())
      .then((response) => {
        dispatch(administratorActions.fetchUserCountTotal(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchUserEducatorCountTotal = () => {
  return (dispatch) => {
    return apiService
      .get(DashboardAPI.educatorCountTotal())
      .then((response) => {
        dispatch(
          administratorActions.fetchUserEducatorCountTotal(response.data)
        );
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchUserLastMonth = () => {
  return (dispatch) => {
    return apiService
      .get(DashboardAPI.userLastMonth())
      .then((response) => {
        dispatch(administratorActions.fetchUserLastMonth(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchReceiptLatest = () => {
  return (dispatch) => {
    return apiService
      .get(DashboardAPI.receiptLatest())
      .then((response) => {
        dispatch(administratorActions.fetchReceiptLatest(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchNewUsers = () => {
  return (dispatch) => {
    return apiService
      .get(DashboardAPI.newUsers())
      .then((response) => {
        dispatch(administratorActions.fetchNewUsers(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchBestChannels = () => {
  return (dispatch) => {
    return apiService
      .get(DashboardAPI.bestChannels())
      .then((response) => {
        dispatch(administratorActions.fetchBestChannels(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
